export default __webpack_public_path__ + "static/media/companynamelogo1.669b97f0.png";